import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEvaluate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 22.5L13 23.5L14 20L21.5 12.5L24 15L16.5 22.5Z",
			fill: "#DAD9EF",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 14.5L22 17",
			stroke: "#7284FA",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 20L16.5 22.5",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 23.5H1V2.5H3",
			fill: "#DAD9EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 23.5H1V2.5H3",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 2.5H19V11.5",
			fill: "#DAD9EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 2.5H19V11.5",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 2.5C12 1.4 11.11 0.5 10 0.5C8.89 0.5 8 1.4 8 2.5H5V5.5H15V2.5H12Z",
			fill: "#DAD9EF",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 12.5V4.5H15",
			fill: "#DAD9EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 12.5V4.5H15",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 4.5H3V21.5H11",
			fill: "#DAD9EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 4.5H3V21.5H11",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 9.5H14",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 11.5H14",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 13.5H14",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 15.5H10.5",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgEvaluate;
